export function normalizePlatformSearch(value: string): string {
  return value
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLocaleLowerCase()
    .trim();
}

// A busca aceita palavras fora de ordem e ignora caixa/acentos. Assim,
// "relatorios chamadas" encontra "Chamadas em andamento" dentro de
// "Relatórios" sem exigir que a pessoa conheça o nome exato da tela.
export function platformSearchScore(value: string, search: string): number {
  const normalizedValue = normalizePlatformSearch(value);
  const terms = normalizePlatformSearch(search).split(/\s+/).filter(Boolean);
  return terms.every((term) => normalizedValue.includes(term)) ? 1 : 0;
}
